module.exports = __webpack_public_path__ + "static/media/insta_logo.db0ef3bd.gif";